import { useState } from 'react';
import axios from 'axios';
import Selector from '../../components/forms/Selector';

const RICHNESS_OPTIONS = [
   { value: 'short', label: 'Коротко' },
   { value: 'standard', label: 'Стандартно' },
   { value: 'detailed', label: 'Детально' },
];

// One-click AI flesh-out for a single Topic - v1a of the AI-course-
// generation feature (see project memory / the approved plan doc for the
// full design). Two independent actions, each its own synchronous backend
// call (POST /api/course-gen/topic/{id}/text|exercise) - deliberately NOT
// one combined "generate everything" button: splitting text generation
// from exercise generation into separate, focused AI calls produces more
// reliable output than one call juggling both, and lets an admin run
// either alone (e.g. write the topic by hand, still AI-generate just the
// exercise). Content richness is a first-class control here, not an
// afterthought - AI defaults to short/thin text, which is exactly the
// complaint that started this feature.
export default function AiTopicGenerationPanel({ topicId, onGenerated }) {
   const [richness, setRichness] = useState('standard');
   const [levelId, setLevelId] = useState('');
   const [textLoading, setTextLoading] = useState(false);
   const [exerciseLoading, setExerciseLoading] = useState(false);
   const [error, setError] = useState('');

   const handleGenerateText = () => {
      setError('');
      setTextLoading(true);
      axios.post('/api/course-gen/topic/' + topicId + '/text', { contentRichness: richness }, { withCredentials: true })
         .then(() => onGenerated())
         .catch(() => setError('Не вдалося згенерувати текст теми. Спробуйте ще раз.'))
         .finally(() => setTextLoading(false));
   };

   const handleGenerateExercise = () => {
      setError('');
      setExerciseLoading(true);
      axios.post('/api/course-gen/topic/' + topicId + '/exercise', { levelId: levelId || null }, { withCredentials: true })
         .then(() => onGenerated())
         .catch(() => setError('Не вдалося створити вправу. Спробуйте ще раз.'))
         .finally(() => setExerciseLoading(false));
   };

   return (
      <div className='topic-panel ai-topic-gen-panel'>
         <h3 className='topic-panel-title'>✨ AI</h3>
         <div className='ai-topic-gen-group'>
            <button type='button' className='ai-topic-gen-btn' onClick={handleGenerateText} disabled={textLoading}>
               {textLoading ? 'Генерація...' : 'Текст теми'}
            </button>
            <select className='ai-topic-gen-select-compact' value={richness}
               onChange={(e) => setRichness(e.target.value)} disabled={textLoading}>
               {RICHNESS_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
         </div>
         <div className='ai-topic-gen-group'>
            <button type='button' className='ai-topic-gen-btn' onClick={handleGenerateExercise} disabled={exerciseLoading}>
               {exerciseLoading ? 'Генерація...' : 'Вправа'}
            </button>
            <Selector className='submit-field form-selection txt-c ai-topic-gen-select-compact'
               name='level' url='/api/levels' value={levelId}
               selectorsHundler={(value) => setLevelId(value)} disabled={exerciseLoading} />
         </div>
         {error ? <p className='ai-topic-gen-error'>{error}</p> : ''}
      </div>
   );
}
